/* eslint-disable @typescript-eslint/default-param-last */
import { MEASURES_SET } from './actions';

const initialState = null;

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case MEASURES_SET:
      return action.payload;

    default:
      return state;
  }
};

export default reducer;
